import React from 'react';
import { ItemResponse } from '@/api/bol';
import { DeleteConfirmDialog } from '@/components/common/DeleteConfirmDialog';

export interface ItemDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  item: ItemResponse | null;
}

export const ItemDeleteDialog: React.FC<ItemDeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  item,
}) => {
  return (
    <DeleteConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      itemType="item"
      itemId={item?.id || ''}
    />
  );
};
